import React from "react"
import "./MarkettingBanner.scss"
import { isEmpty } from "lodash"
import { Container } from "react-bootstrap"
import { parseHTML } from "@lib/utils"
import CTALink from "@components/elements/CTALink"
import clsx from "clsx"
import PlayVideoButton from "@components/elements/PlayVideo/PlayVideoButton"
import PlayOutlineIcon from "@components/icons/PlayOutlineIcon"
import GGFXImage from "@components/elements/GGFXImage"

const SearchResultMarketingBanner = ({
  module,
  noContainer,
  sectionClassName,
  algoliaData,
  propertyIndex,
}) => {
  if (isEmpty(module)) return null
  const { marketing_banner: marketingBanner } = module
  const cardOffset = 4

  if (isEmpty(marketingBanner)) return null

  let bannerData = marketingBanner[0]

  if (typeof propertyIndex === "number") {
    if (!isEmpty(algoliaData) && (propertyIndex + 1) % cardOffset === 0) {
      const { hits, currentPageNumber } = algoliaData
      const hitsPerPage = hits?.length || 0

      const currentPagePropertyIndex =
        currentPageNumber * hitsPerPage + propertyIndex

      const bannerTempIndex = Math.floor(currentPagePropertyIndex / cardOffset)

      const bannerIndex = Math.floor(bannerTempIndex % marketingBanner.length)

      if (bannerIndex > marketingBanner.length) {
        console.error(
          `Invalid banner index ${bannerIndex} for property index ${propertyIndex}.
          Max banner index is ${marketingBanner.length - 1}.`,
        )

        return null
      }

      bannerData = marketingBanner[bannerIndex]
    } else return null
  }

  if (isEmpty(bannerData)) return null

  const {
    background_image,
    ctas,
    title_content,
    video_label,
    video_url,
    imagetransforms,
    strapi_id,
    ggfx_results,
  } = bannerData

  const Comp = noContainer ? "div" : Container

  let processedImages =
    imagetransforms?.internal?.content?.background_image_Transforms
  processedImages ||= JSON.stringify({})

  return (
    <Comp
      className={`marketting-banner-wrap ${sectionClassName || "section-m"}`}
    >
      <div
        className={`marketting-banner-section ${
          title_content?.data?.title_content ? "" : "no_content"
        }`}
      >
        <div className="bg-img-section">
          {/* <img
            src={background_image?.url}
            alt="marketting-banner"
            className="bg-img"
          /> */}
          <GGFXImage
            ImageSrc={background_image}
            altText="marketting-banner"
            imagetransforms={ggfx_results}
            renderer="srcSet"
            imagename="marketing-banner.background_image.image"
            strapiID={strapi_id}
            className="bg-img"
          />
        </div>
        <div className="marketting-banner-content">
          <div className="marketting-banner-content__title-content">
            {parseHTML(title_content?.data?.title_content)}
          </div>
          <div className="marketting-banner-content__cta-section">
            {!isEmpty(ctas) &&
              ctas?.map((cta, index) => (
                <CTALink
                  key={cta?.id}
                  cta={cta}
                  className={clsx(
                    "button",
                    index % 2 === 0 ? "button-primary" : "button-outline-white",
                  )}
                />
              ))}
          </div>
          {video_label && (
            <div className="marketting-banner-content__video">
              <PlayVideoButton
                videoUrl={video_url}
                className="marketting-banner-content__video-btn"
              >
                <PlayOutlineIcon />
                <span>{video_label}</span>
              </PlayVideoButton>
            </div>
          )}
        </div>
      </div>
    </Comp>
  )
}

export default SearchResultMarketingBanner
